// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/asset/fonts/General-Sans/GeneralSans-Bold.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Semi Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Regular Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Medium Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Bold Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-display: swap;
}
.vrise-green {
  border: 0.5px solid var(--accent-primary-dark-green-color);
  background: var(--accent-secondary-dark-green-color);
  color: var(--accent-primary-dark-green-color);
}

.vrise-red {
  border: 0.5px solid var(--accent-primary-red-color);
  background: var(--accent-secondary-red-color);
  color: var(--accent-primary-red-color);
}

.vrise-yellow {
  border-radius: 8px;
  border: 0.5px solid var(--accent-primary-yellow-color);
  background: var(--accent-tertiary-yellow-color);
  color: var(--accent-primary-yellow-color);
}

.vrise-grey {
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--quartinary-surface-color);
  color: var(--primary-text-color);
}

.break-line {
  background: var(--border-color);
}

.vcard {
  align-items: flex-start;
  background: var(--primary-surface-color);
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  overflow: hidden;
  padding: 16px;
  position: relative;
}

.placed-status {
  background: url("https://wordpress.herovired.com/wp-content/uploads/2025/04/Bg-6-1.png") center/cover, var(--vrise-placed-status);
}

.vcard .designation {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 12px;
  position: relative;
}

.vcard .div {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 4px;
  position: relative;
}

.vcard .text-wrapper {
  color: var(--primary-text-color);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%; /* 14px */
}

.vcard .text-wrapper-2 {
  color: var(--tertiary-text-color);
  font-size: 12px;
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 12px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.vcard .line {
  align-self: stretch;
  height: 1px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.vcard .div-2 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.vcard .info {
  align-items: flex-start;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 60px;
  position: relative;
  color: var(--tertiary-text-color);
}

.vcard .label {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  position: relative;
}

.vcard .img {
  height: 16px;
  position: relative;
  width: 16px;
}

.vcard .text-wrapper-3 {
  color: var(--tertiary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 125%; /* 15px */
}

.vcard .text-wrapper-4 {
  color: var(--secondary-text-color);
  font-style: normal;
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}

.vcard .data {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  width: 114px;
}

.vcard .status {
  align-items: flex-end;
  display: inline-flex;
  flex: 0 0 auto;
  flex-direction: column;
  gap: 8px;
  position: relative;
}

.vcard .text-wrapper-5 {
  color: var(--secondary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
  padding-right: 4px;
}

.vcard .tag {
  align-items: center;
  border-radius: 24px;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 4px;
  justify-content: center;
  padding: 8px 12px 8px 10px;
  position: relative;
}

.vcard .status-icon {
  font-size: 16px;
}

.vcard .text-wrapper-6 {
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
  margin-top: -1px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
}

.vcard .text-wrapper-7 {
  color: var(--quartinary-text-color);
  font-family: "Medium Sans", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 125%; /* 17.5px */
}

.vcard .CTA {
  all: unset;
  align-items: center;
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  position: relative;
}

.vcard .text-wrapper-8 {
  color: var(--Color-Accent-Shade-1, #5095fc);
  font-family: "Semi Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%; /* 14px */
}

.vcard .arrow-drop-down {
  height: 20px;
  position: relative;
  width: 18px;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/components/VRiseCard/VRiseStatusCard.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACAF;ADGA;EACE,2BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACFF;ADIA;EACE,0BAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACHF;ADKA;EACE,wBAAA;EACA,4CAAA;EACA,+DAAA;EAEA,kBAAA;ACJF;AArBA;EACI,0DAAA;EACA,oDAAA;EACA,6CAAA;AAuBJ;;AApBA;EACI,mDAAA;EACA,6CAAA;EACA,sCAAA;AAuBJ;;AApBA;EACI,kBAAA;EACA,sDAAA;EACA,+CAAA;EACA,yCAAA;AAuBJ;;AApBA;EACI,kBAAA;EACA,qCAAA;EACA,2CAAA;EACA,gCAAA;AAuBJ;;AApBA;EACI,+BAAA;AAuBJ;;AApBA;EACI,uBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAuBJ;;AApBA;EACI,iIACI;AAsBR;;AAlBA;EACI,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAqBJ;;AAdA;EACI,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAiBJ;;AAdA;EACI,gCAAA;ECjCF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDiCE,eAAA;EACA,iBAAA,EAAA,SAAA;AAmBJ;;AAhBA;EACI,iCAAA;EACA,eAAA;EC9CF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED8CE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAqBJ;;AAlBA;EACI,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AAqBJ;;AAlBA;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;AAqBJ;;AAlBA;EACI,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,iCAAA;AAqBJ;;AAlBA;EACI,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;AAqBJ;;AAlBA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAqBJ;;AAlBA;EACI,iCAAA;EClGF,sCAAA;EACA,kBAAA;EACA,gBAAA;EDkGE,eAAA;EACA,iBAAA,EAAA,SAAA;AAuBJ;;AApBA;EACI,kCAAA;EACA,kBAAA;EC1GF,sCAAA;EACA,kBAAA;EACA,gBAAA;ED0GE,eAAA;EACA,iBAAA,EAAA,WAAA;AAyBJ;;AAtBA;EACI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAyBJ;;AAtBA;EACI,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AAyBJ;;AAtBA;EACI,kCAAA;ECnIF,sCAAA;EACA,kBAAA;EACA,gBAAA;EDmIE,eAAA;EACA,iBAAA,EAAA,WAAA;EACA,kBAAA;AA2BJ;;AAxBA;EACI,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,QAAA;EACA,uBAAA;EACA,0BAAA;EACA,kBAAA;AA2BJ;;AAxBA;EACI,eAAA;AA2BJ;;AAxBA;ECzJE,sCAAA;EACA,kBAAA;EACA,gBAAA;EDyJE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AA6BJ;;AA1BA;EACI,mCAAA;ECrKF,sCAAA;EACA,kBAAA;EACA,gBAAA;EDqKE,eAAA;EACA,iBAAA,EAAA,WAAA;AA+BJ;;AA5BA;EACI,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;AA+BJ;;AA5BA;EACI,2CAAA;ECjLF,oCAAA;EACA,kBAAA;EACA,gBAAA;EDiLE,eAAA;EACA,iBAAA,EAAA,SAAA;AAiCJ;;AA9BA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AAiCJ","sourcesContent":["@font-face {\n  font-family: 'Semi Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Semibold.otf')\n    format('truetype');\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Regular Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Regular.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Medium Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Medium.otf')\n    format('truetype');\n  font-display: swap;\n}\n@font-face {\n  font-family: 'Bold Sans';\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf');\n  src: url('/src/asset/fonts/General-Sans/GeneralSans-Bold.otf')\n    format('truetype');\n  font-display: swap;\n}\n","@import \"../../styles/styles.scss\";\n\n.vrise-green {\n    border: 0.5px solid var(--accent-primary-dark-green-color);\n    background: var(--accent-secondary-dark-green-color);\n    color: var(--accent-primary-dark-green-color);\n}\n\n.vrise-red {\n    border: 0.5px solid var(--accent-primary-red-color);\n    background: var(--accent-secondary-red-color);\n    color: var(--accent-primary-red-color);\n}\n\n.vrise-yellow {\n    border-radius: 8px;\n    border: 0.5px solid var(--accent-primary-yellow-color);\n    background: var(--accent-tertiary-yellow-color);\n    color: var(--accent-primary-yellow-color);\n}\n\n.vrise-grey {\n    border-radius: 8px;\n    border: 1px solid var(--border-color);\n    background: var(--quartinary-surface-color);\n    color: var(--primary-text-color);\n}\n\n.break-line {\n    background: var(--border-color);\n}\n\n.vcard {\n    align-items: flex-start;\n    background: var(--primary-surface-color);\n    border: 1px solid;\n    border-color: var(--border-color);\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    justify-content: center;\n    overflow: hidden;\n    padding: 16px;\n    position: relative;\n}\n\n.placed-status {\n    background:\n        url(\"https://wordpress.herovired.com/wp-content/uploads/2025/04/Bg-6-1.png\") center/cover,\n        var(--vrise-placed-status);\n}\n\n.vcard .designation {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 12px;\n    position: relative;\n}\n\n// .vcard .image-div {\n\n// }\n\n.vcard .div {\n    align-items: flex-start;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 4px;\n    position: relative;\n}\n\n.vcard .text-wrapper {\n    color: var(--primary-text-color);\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 100%; /* 14px */\n}\n\n.vcard .text-wrapper-2 {\n    color: var(--tertiary-text-color);\n    font-size: 12px;\n    @include MediumSans;\n    letter-spacing: 0;\n    line-height: 12px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.vcard .line {\n    align-self: stretch;\n    height: 1px;\n    object-fit: cover;\n    position: relative;\n    width: 100%;\n}\n\n.vcard .div-2 {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: space-between;\n    position: relative;\n    width: 100%;\n}\n\n.vcard .info {\n    align-items: flex-start;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 60px;\n    position: relative;\n    color: var(--tertiary-text-color);\n}\n\n.vcard .label {\n    align-items: center;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 4px;\n    justify-content: center;\n    position: relative;\n}\n\n.vcard .img {\n    height: 16px;\n    position: relative;\n    width: 16px;\n}\n\n.vcard .text-wrapper-3 {\n    color: var(--tertiary-text-color);\n    @include MediumSans;\n    font-size: 12px;\n    line-height: 125%; /* 15px */\n}\n\n.vcard .text-wrapper-4 {\n    color: var(--secondary-text-color);\n    font-style: normal;\n    @include MediumSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n}\n\n.vcard .data {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    position: relative;\n    width: 114px;\n}\n\n.vcard .status {\n    align-items: flex-end;\n    display: inline-flex;\n    flex: 0 0 auto;\n    flex-direction: column;\n    gap: 8px;\n    position: relative;\n}\n\n.vcard .text-wrapper-5 {\n    color: var(--secondary-text-color);\n    @include MediumSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n    padding-right: 4px;\n}\n\n.vcard .tag {\n    align-items: center;\n    border-radius: 24px;\n    display: inline-flex;\n    flex: 0 0 auto;\n    gap: 4px;\n    justify-content: center;\n    padding: 8px 12px 8px 10px;\n    position: relative;\n}\n\n.vcard .status-icon {\n    font-size: 16px;\n}\n\n.vcard .text-wrapper-6 {\n    @include MediumSans;\n    font-size: 14px;\n    letter-spacing: 0;\n    line-height: 14px;\n    margin-top: -1px;\n    position: relative;\n    white-space: nowrap;\n    width: fit-content;\n}\n\n.vcard .text-wrapper-7 {\n    color: var(--quartinary-text-color);\n    @include MediumSans;\n    font-size: 14px;\n    line-height: 125%; /* 17.5px */\n}\n\n.vcard .CTA {\n    all: unset;\n    align-items: center;\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 0 0 auto;\n    justify-content: center;\n    position: relative;\n}\n\n.vcard .text-wrapper-8 {\n    color: var(--Color-Accent-Shade-1, #5095fc);\n    @include SemiSans;\n    font-size: 14px;\n    line-height: 100%; /* 14px */\n}\n\n.vcard .arrow-drop-down {\n    height: 20px;\n    position: relative;\n    width: 18px;\n}\n","@mixin flex($direction: row, $align-items: center, $justify-content: center) {\n  display: flex;\n  flex-direction: $direction;\n  align-items: $align-items;\n  justify-content: $justify-content;\n}\n\n@mixin container {\n  margin: auto;\n  max-width: 1920px;\n}\n\n@mixin s_container {\n  max-width: 1536px;\n  margin: 0 auto;\n  padding: 0 32px;\n\n  @include l_desktop {\n    max-width: 1320px;\n  }\n\n  @include s_tablet {\n    padding: 0 16px;\n  }\n}\n\n@mixin box($width, $height: $width) {\n  width: $width;\n  height: $height;\n}\n\n// FONT ISSUE NOT MATCHING NEED TO GRAB NEW FONTS\n@mixin RegularSans {\n  font-family: 'Regular Sans', sans-serif;\n  font-style: normal;\n}\n@mixin MediumSans {\n  font-family: 'Medium Sans', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n}\n@mixin SemiSans {\n  font-family: 'Semi Sans', sans-serif;\n  font-style: normal;\n  font-weight: 600;\n}\n@mixin BoldSans {\n  font-family: 'Bold Sans', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n}\n@mixin IBMPlexMonoMedium {\n  font-family: 'IBM Plex Mono', monospace;\n  font-weight: 500;\n  font-style: normal;\n}\n\n\n@mixin auth-heading {\n  @include Playfair;\n  line-height: 1.875rem;\n  font-weight: 600;\n  letter-spacing: -3%;\n  font-size: 2rem;\n  @include s_tablet {\n    font-size: 1.8rem;\n  }\n}\n\n@mixin auth-subheading {\n  @include Inter;\n  line-height: 1.875rem;\n  font-weight: 400;\n  font-size: 1rem;\n  @include s_tablet {\n    font-size: 0.9rem;\n  }\n}\n@mixin validation-text {\n  color: #ff0000;\n  font-size: 0.875rem;\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n@mixin respond-to($max-width) {\n  @media (max-width: $max-width) {\n    @content;\n  }\n}\n@mixin respond-to-min($max-width) {\n  @media (min-width: $max-width) {\n    @content;\n  }\n}\n\n@mixin respond-to-height($max-height) {\n  @media (max-height: $max-height) {\n    @content;\n  }\n}\n\n@mixin larger_desktop {\n  @media (min-width: 1920px) {\n    @content;\n  }\n}\n@mixin l_desktop {\n  @media (min-width: 1536px) {\n    @content;\n  }\n}\n\n@mixin sm_desktop {\n  @media (max-width: 1350px) {\n    @content;\n  }\n}\n\n@mixin m_desktop {\n  @media (max-width: 1199px) {\n    @content;\n  }\n}\n\n@mixin s_desktop {\n  @media (max-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin l_tablet {\n  @media (max-width: 991px) {\n    @content;\n  }\n}\n\n@mixin m_tablet {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm_tablet {\n  @media (min-width: 601px) and (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin s_tablet {\n  @media (max-width: 550px) {\n    @content;\n  }\n}\n@mixin l_mobile {\n  @media (max-width: 425px) {\n    @content;\n  }\n}\n@mixin m_mobile {\n  @media (max-width: 375px) {\n    @content;\n  }\n}\n@mixin s_mobile {\n  @media (max-width: 350px) {\n    @content;\n  }\n}\n@mixin xs_mobile {\n  @media (max-width: 300px) {\n    @content;\n  }\n}\n@mixin safari_specific_style {\n  @supports (-webkit-touch-callout: none) {\n    @content;\n  }\n}\n@mixin hide_scrollbar {\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  & {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n}\n\n@mixin underline_animation {\n  overflow: hidden;\n  background: linear-gradient(currentColor 0 0) 0 100% / var(--d, 0) 1px\n    no-repeat;\n  transition: 0.5s;\n  &:hover {\n    --d: 100%;\n  }\n}\n\n@mixin bounceInRight($duration: 0.5s) {\n  @-webkit-keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  @keyframes bounceInRight {\n    0% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n    100% {\n      -webkit-transform: translateX(0);\n    }\n  }\n}\n\n@mixin bounceOutRight($duration: 0.5s) {\n  @-webkit-keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      -webkit-transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      -webkit-transform: translateX(2000px);\n    }\n  }\n\n  @keyframes bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translateX(-10px);\n    }\n    100% {\n      opacity: 0;\n      transform: translateX(2000px);\n    }\n  }\n\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@mixin remove_userTapColor {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n@mixin ellipsis($line: 4) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: $line; /* Set the number of lines to be shown */\n  -webkit-box-orient: vertical;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
